(function () {
  'use strict';

  var COST_PER_SEC = { '1080p': 0.04, '1440p': 0.08, '2160p': 0.16 };
  var MARKUP = 1.2;

  function init() {
    if (typeof jQuery === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    jQuery(document).ready(function () {
      setupGenerate();
      updateCost();
    });
  }

  function setupGenerate() {
    jQuery('#ltx23-generate').on('click', generateVideo);
    jQuery('#ltx23-duration, #ltx23-resolution').on('change', updateCost);
  }

  function updateCost() {
    var duration = parseFloat(jQuery('#ltx23-duration').val()) || 6;
    var resolution = jQuery('#ltx23-resolution').val() || '1080p';
    var base = COST_PER_SEC[resolution] || 0.04;
    var cost = base * duration * MARKUP;
    jQuery('#ltx23-cost').text('$' + cost.toFixed(2));
  }

  function getAuthSecret() {
    var creds =
      typeof window.getAuthCredentials === 'function'
        ? window.getAuthCredentials()
        : null;
    if (creds && creds.secret) return creds.secret;
    if (window.userData && window.userData.secret)
      return window.userData.secret;
    return '';
  }

  function showNotification(message, type) {
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.showNotification === 'function'
    ) {
      window.NetwrckTools.showNotification(message, type || 'info');
      return;
    }
    if (typeof window.showSnackbar === 'function') {
      window.showSnackbar(message);
      return;
    }
    if (type === 'error') alert(message);
  }

  function appendLog(text) {
    var logs = jQuery('#generation-logs');
    logs.append('<div>' + text + '</div>');
    logs.scrollTop(logs[0].scrollHeight);
  }

  async function generateVideo() {
    var prompt = jQuery('#ltx23-prompt').val().trim();
    if (!prompt) {
      showNotification('Enter a prompt', 'error');
      return;
    }

    var duration = parseFloat(jQuery('#ltx23-duration').val()) || 6;
    var resolution = jQuery('#ltx23-resolution').val() || '1080p';
    var base = COST_PER_SEC[resolution] || 0.04;
    var cost = base * duration * MARKUP;
    var credits = Math.ceil(cost * 100);

    var secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      return;
    }
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    )
      return;

    jQuery('#ltx23-loading').show();
    jQuery('#generation-logs').empty().show();
    appendLog('Submitting request...');

    var payload = {
      api_key: secret,
      prompt: prompt,
      duration: duration,
      resolution: resolution,
      aspect_ratio: jQuery('#ltx23-aspect').val() || '16:9',
      fps: parseInt(jQuery('#ltx23-fps').val(), 10) || 25,
      generate_audio: jQuery('#ltx23-audio').is(':checked'),
      response_mode: 'polling',
    };

    try {
      var response = await fetch('/api/ltx-text-to-video', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: 'Bearer ' + secret,
        },
        body: JSON.stringify(payload),
      });

      var data = await response.json();

      if (!response.ok) {
        appendLog('Error: ' + (data.error || 'Request failed'));
        jQuery('#ltx23-loading').hide();
        return;
      }

      if (response.status === 202 && data.job_id) {
        appendLog('Job queued: ' + data.job_id);
        pollJob(data.job_id, secret);
        return;
      }

      var url =
        (data.result && data.result.video && data.result.video.url) ||
        (data.video && data.video.url) ||
        data.video_url;
      if (url) {
        showVideo(url);
        appendLog('Generation complete');
      } else {
        appendLog('Generation failed - no video in response');
      }
      jQuery('#ltx23-loading').hide();
    } catch (err) {
      appendLog('Error: ' + err.message);
      jQuery('#ltx23-loading').hide();
    }
  }

  function pollJob(jobId, secret) {
    fetch('/api/fal/status/' + jobId + '?api_key=' + encodeURIComponent(secret))
      .then(function (resp) {
        return resp.json();
      })
      .then(function (data) {
        if (data.status === 'completed') {
          var url =
            (data.result && data.result.video && data.result.video.url) ||
            (data.result &&
              data.result.result &&
              data.result.result.video &&
              data.result.result.video.url) ||
            (data.result && data.result.video_url);
          if (url) {
            showVideo(url);
            appendLog('Generation complete');
          } else {
            appendLog('No video in result');
          }
          jQuery('#ltx23-loading').hide();
          return;
        }
        if (data.status === 'failed') {
          appendLog('Generation failed');
          jQuery('#ltx23-loading').hide();
          return;
        }
        appendLog('Working...');
        setTimeout(function () {
          pollJob(jobId, secret);
        }, 4000);
      })
      .catch(function () {
        setTimeout(function () {
          pollJob(jobId, secret);
        }, 6000);
      });
  }

  function showVideo(videoUrl) {
    var videoHtml =
      '<div class="ai-video-item mdl-cell mdl-cell--stretch mdl-cell--12-col mdl-list__item">' +
      '<video controls autoplay loop style="max-width: 100%;"><source src="' +
      videoUrl +
      '" type="video/mp4"></video>' +
      '<div style="margin-top: 8px;"><a href="' +
      videoUrl +
      '" target="_blank" download style="color: #0f766e;">Download Video</a></div>' +
      '</div>';
    jQuery('#createdVideoList').prepend(videoHtml);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
